import { Link } from 'react-router-dom';

export default function ExpertReviews() {
  const highlights = [
    {
      icon: 'ri-checkbox-circle-fill',
      iconBg: 'from-emerald-400 to-green-500',
      title: 'Comprehensive Testing',
      description: 'We test games, payment speed, support quality, bonus terms, and security before publishing.',
    },
    {
      icon: 'ri-shield-check-fill',
      iconBg: 'from-blue-400 to-indigo-500',
      title: 'Licensed & Verified',
      description: 'Only casinos that pass licensing and trust checks are considered for our top rankings.',
    },
    {
      icon: 'ri-refresh-fill',
      iconBg: 'from-orange-400 to-red-500',
      title: 'Regular Updates',
      description: 'Our experts re-check reviews frequently so rankings stay current and relevant.',
    },
  ];

  return (
    <section className="py-16 md:py-10 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-[1.05fr_0.95fr] gap-8 lg:gap-12 items-center">
          <div className="order-2 lg:order-1">
            <div className="inline-block px-4 py-2 bg-purple-100 text-purple-700 rounded-full text-xs md:text-sm font-bold tracking-wide">
              MEET OUR EXPERTS
            </div>

            <h2 className="mt-4 text-2xl md:text-4xl font-bold text-gray-900 leading-tight">
              Reviews by{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-indigo-600">
                KoalaBet experts
              </span>
            </h2>

            <p className="mt-4 text-md md:text-lg text-gray-600 leading-relaxed max-w-2xl">
              Our review team uses a clear scoring framework built around what matters to players:
              safety, payout speed, fair terms, and real gameplay quality. No paid placement can
              override our standards.
            </p>

            <div className="mt-6 grid grid-cols-2 sm:grid-cols-4 gap-3">
              <div className="rounded-xl bg-white border border-gray-200 px-4 py-3">
                <div className="text-xl font-bold text-gray-900">200+</div>
                <div className="text-xs text-gray-600">checkpoints</div>
              </div>
              <div className="rounded-xl bg-white border border-gray-200 px-4 py-3">
                <div className="text-xl font-bold text-gray-900">24-48h</div>
                <div className="text-xs text-gray-600">payout checks</div>
              </div>
              <div className="rounded-xl bg-white border border-gray-200 px-4 py-3">
                <div className="text-xl font-bold text-gray-900">Monthly</div>
                <div className="text-xs text-gray-600">re-validation</div>
              </div>
              <div className="rounded-xl bg-white border border-gray-200 px-4 py-3">
                <div className="text-xl font-bold text-gray-900">100%</div>
                <div className="text-xs text-gray-600">independent</div>
              </div>
            </div>

            <div className="mt-6 space-y-3">
              {highlights.map((item) => (
                <div
                  key={item.title}
                  className="flex items-start gap-4 bg-white rounded-xl border border-gray-200 p-4"
                >
                  <div
                    className={`w-11 h-11 bg-gradient-to-br ${item.iconBg} rounded-lg flex items-center justify-center flex-shrink-0`}
                  >
                    <i className={`${item.icon} text-xl text-white`}></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900 mb-1">{item.title}</h4>
                    <p className="text-sm md:text-base text-gray-600">{item.description}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-7 flex flex-wrap gap-3">
              <Link
                to="/methodology"
                className="px-6 py-3 bg-gradient-to-r from-purple-600 to-indigo-600 text-white font-semibold rounded-full hover:shadow-lg transition-all"
              >
                Read Our Methodology
              </Link>
            </div>
          </div>

          <div className="relative order-1 lg:order-2">
            <div className="absolute -inset-3 bg-gradient-to-r from-purple-500 to-indigo-500 rounded-3xl blur-2xl opacity-20"></div>
            <div className="relative bg-white p-3 rounded-3xl border border-gray-200 shadow-xl">
              <img
                src="https://readdy.ai/api/search-image?query=professional%20casino%20expert%20reviewer%20in%20modern%20office%20with%20multiple%20monitors%20showing%20casino%20websites%2C%20confident%20business%20person%20analyzing%20data%2C%20bright%20professional%20lighting%2C%20high%20quality%20photography&width=700&height=600&seq=expertreview001&orientation=landscape"
                alt="KoalaBet expert reviewing casino platforms"
                className="w-full h-[280px] md:h-[360px] object-cover rounded-2xl"
              />
              <div className="mt-3 flex items-center justify-between bg-gray-50 border border-gray-200 rounded-xl px-4 py-3">
                <span className="text-sm text-gray-600">Latest quality re-check</span>
                <span className="text-sm font-semibold text-emerald-700">Updated this month</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}